(function () {
    const popularProductsSlider = () => {
        const sliders = document.querySelectorAll(".popular__container");

        sliders.forEach((slider) => {
            console.log("Initializing popular products slider");
            const parent = slider.closest(".popular-products");

            // Get the section ID from the data attribute
            const sectionId = slider.getAttribute("data-section-id");
            console.log("Section ID:", sectionId);

            // Use section-specific selectors with sectionId to ensure unique targeting
            const prevArrow = document.querySelector(
                `.section-${sectionId}-prev`
            );
            const nextArrow = document.querySelector(
                `.section-${sectionId}-next`
            );
            const sliderNav = document.querySelector(
                `.section-${sectionId}-nav`
            );

            // Default configuration values
            const columns1360 = 4; // Maximum number of columns
            const columns1200 = 4;
            const columns990 = 3;
            const columns576 = 2;

            // Get number of slides to determine if arrows should be shown
            const slides = slider.querySelectorAll(".swiper-slide");
            const hasMultipleSlides = slides.length > 1;

            // Show arrows only if there are enough slides
            if (prevArrow && nextArrow) {
                if (hasMultipleSlides) {
                    prevArrow.style.display = "flex";
                    nextArrow.style.display = "flex";
                } else {
                    prevArrow.style.display = "none";
                    nextArrow.style.display = "none";
                }
            }

            // Make sure the slider nav is visible on all screen sizes if enough slides
            const updateSliderNav = () => {
                if (sliderNav) {
                    if (hasMultipleSlides) {
                        sliderNav.classList.remove("no-js-hidden");

                        // Check if slides need navigation on desktop
                        const screenWidth = window.innerWidth;
                        if (screenWidth >= 576) {
                            // Check if number of slides is greater than visible slides
                            if (
                                (screenWidth >= 1360 &&
                                    slides.length > columns1360) ||
                                (screenWidth >= 1200 &&
                                    screenWidth < 1360 &&
                                    slides.length > columns1200) ||
                                (screenWidth >= 990 &&
                                    screenWidth < 1200 &&
                                    slides.length > columns990) ||
                                (screenWidth >= 576 &&
                                    screenWidth < 990 &&
                                    slides.length > columns576)
                            ) {
                                sliderNav.classList.add("show-desktop-nav");
                            } else {
                                sliderNav.classList.remove("show-desktop-nav");
                            }
                        }
                    } else {
                        sliderNav.classList.add("no-js-hidden");
                    }
                }
            };

            // Initialize the Swiper instance
            let popularProducts;

            const initSlider = () => {
                // Destroy existing instance if it exists
                if (
                    slider.swiper &&
                    typeof slider.swiper.destroy === "function"
                ) {
                    slider.swiper.destroy(true, true);
                }

                // Only initialize if there are multiple slides
                if (hasMultipleSlides) {
                    popularProducts = new Swiper(slider, {
                        slidesPerView: 1.2,
                        spaceBetween: 8,
                        navigation: {
                            nextEl: `.section-${sectionId}-next`,
                            prevEl: `.section-${sectionId}-prev`,
                        },
                        watchOverflow: true, // Disables navigation when there are not enough slides
                        breakpoints: {
                            576: {
                                slidesPerView: columns576,
                                slidesPerGroup: 1,
                            },
                            990: {
                                slidesPerView: columns990,
                                slidesPerGroup: 1,
                            },
                            1200: {
                                slidesPerView: columns1200,
                                slidesPerGroup: 1,
                            },
                            1360: {
                                slidesPerView: columns1360,
                                slidesPerGroup: 1,
                            },
                        },
                        on: {
                            init: function () {
                                updateSliderNav();
                                // Store the swiper instance directly on the slider element
                                slider.swiper = this;
                            },
                            resize: function () {
                                updateSliderNav();
                            },
                        },
                    });
                }
            };

            // Initialize the slider
            initSlider();

            // Create unique resize event listener for this slider
            const resizeHandler = () => {
                initSlider();
            };

            // Store the resize handler on the element for later cleanup
            slider.resizeHandler = resizeHandler;

            // Add resize event listener
            window.addEventListener("resize", resizeHandler);
        });
    };

    // Initialize on page load
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", popularProductsSlider);
    } else {
        popularProductsSlider();
    }

    // Reinitialize when Shopify sections reload
    document.addEventListener("shopify:section:load", function (event) {
        if (event.target.classList.contains("popular-products-section")) {
            // Delay initialization slightly to ensure DOM is fully updated
            setTimeout(popularProductsSlider, 100);
        }
    });

    // Handle Shopify section unload and properly cleanup
    document.addEventListener("shopify:section:unload", function (event) {
        if (event.target.classList.contains("popular-products-section")) {
            const sliders = event.target.querySelectorAll(
                ".popular__container"
            );

            sliders.forEach((slider) => {
                // Remove the resize event listener to prevent memory leaks
                if (slider.resizeHandler) {
                    window.removeEventListener("resize", slider.resizeHandler);
                    slider.resizeHandler = null;
                }

                // Destroy the Swiper instance
                if (
                    slider.swiper &&
                    typeof slider.swiper.destroy === "function"
                ) {
                    slider.swiper.destroy(true, true);
                    slider.swiper = null;
                }
            });
        }
    });
})();
